var timeout;
var notification;
var allowFormSubmit = true;

const hamburger = document.querySelector(".hamburger");
if (hamburger) {
	hamburger.addEventListener("click", (e) => {
		document.querySelector(".navigation").classList.toggle('hidden');
		hamburger.querySelector('.icon-close').classList.toggle('opacity-0');
		hamburger.querySelector('.icon-menu').classList.toggle('opacity-0');
	}, false);
}

const accordionBtns = document.querySelectorAll(".accordion-heading");
accordionBtns.forEach((accordion, i) => {
	accordionBtns[i].addEventListener("click", (e) => {
		accordionBtns.forEach((a1, i1) => {
			if(i1 != i) {
				a1.querySelector("svg").classList.remove("rotate-180");
				a1.nextElementSibling.classList.add('hidden');
			}
		}, false);

	    let content = accordionBtns[i].nextElementSibling.classList;
		if(content.contains("hidden")) {
	    	accordionBtns[i].querySelector("svg").classList.add("rotate-180");
			content.remove('hidden');
		} else {
	    	accordionBtns[i].querySelector("svg").classList.remove("rotate-180");
			content.add('hidden');;
		}
	}, false);
});

const closeNotificationBtns = document.querySelectorAll(".close-notification");
for (var i = 0; i < closeNotificationBtns.length; i++) {
    closeNotificationBtns[i].addEventListener('click', function(event) {
    	if(timeout) {
    		notification.querySelector(".close-notification").click();
    		clearTimeout(timeout);
    	}
		event.target.closest('.notification').classList.remove("translate-y-0", "opacity-100", "pointer-events-auto", "sm:translate-x-0", "ease-in");
		event.target.closest('.notification').classList.add("translate-y-2", "opacity-0", "pointer-events-none", "sm:translate-y-0", "sm:translate-x-2", "ease-out");
    });
}

const form = document.querySelector('.craft-form');
if(form) {
	form.addEventListener('submit', (e) => {
		e.preventDefault();

		if(! allowFormSubmit) {
			return false;
		}

		allowFormSubmit = false;
		form.querySelector('button[type="submit"]').setAttribute("disabled", "disabled");
		var formData = new FormData(form);
		var fieldErrors = {};
		formData.append('action', 'contact-form/send');
		fetch(form.getAttribute("action"), {
			method: 'POST',
			body: formData,
			headers: {
				'Accept': 'application/json',
			},
		})
		.then(response => response.json())
		.then(data => {
			form.querySelectorAll('.errors').forEach(e => e.remove());

			if(form.querySelector(".h-captcha")) {
			    window.hcaptcha.reset(form.querySelector(".h-captcha").querySelector('iframe').getAttribute("data-hcaptcha-widget-id"));
			}

			if(data.success == true){
				form.reset();
				showNotification(".success-notification");
			} else {
				Object.keys(data.errors).forEach(function(value, index, arr){
					var el = document.createElement("ul");
					el.classList.add("errors", "text-red-600", "text-sm", "mt-1");
					data.errors[value].forEach(function(v1, in1){
						el.innerHTML = el.innerHTML + "<li>" + v1 + "</li>";
					});

					if(value == "hcaptcha") {
					    let div = e.target.querySelector(".h-captcha");
					    insertAfter(el, div);
					} else {
						var input = (value == "message") ? "textarea" : "input";
						var div = document.querySelector(input + "[id='" + value + "']");
						insertAfter(el, div);
					}

				});

				showNotification(".error-notification");
			}
			allowFormSubmit = true;
			form.querySelector('button[type="submit"]').removeAttribute("disabled");
		})
		.catch(err => {
			allowFormSubmit = true;
			form.querySelector('button[type="submit"]').removeAttribute("disabled");
			console.log(err)
		});
	});
}

function insertAfter(newNode, referenceNode)
{
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

function showNotification(node)
{
	if(timeout) {
		notification.querySelector(".close-notification").click();
		clearTimeout(timeout);
	}
	notification = document.querySelector(node);
	if (notification)
	{
		notification.classList.add("translate-y-0", "opacity-100", "pointer-events-auto", "sm:translate-x-0", "ease-in");
		notification.classList.remove("translate-y-2", "opacity-0", "pointer-events-none", "sm:translate-y-0", "sm:translate-x-2", "ease-out");

		timeout = setTimeout(function() {
			notification.querySelector(".close-notification").click();
		}, 5000);
	}
}

window.addEventListener('load', function(event) {
	var notificationExists = document.querySelector('.notifications-wrapper');
	if(notificationExists) {
		notificationExists.removeAttribute("style");
	}
	showNotification(".notification[data-show='yes']")
});